import { configureStore } from "@reduxjs/toolkit";
import app from "./features/app/slice";
import authentication from "./features/authentication/slice";
import { api } from "./api/baseApi";

export const store = configureStore({
	reducer: {
		app,
		authentication,
		[api.reducerPath]: api.reducer
	},
	middleware: (getDefaultMiddleware) =>
		getDefaultMiddleware().concat([api.middleware])
});

export type AppStore = typeof store;
export type RootState = ReturnType<AppStore["getState"]>;
export type AppDispatch = AppStore["dispatch"];
